import React from 'react';
import styles from './not-found.page.module.scss';

export const NotFound: React.FC = () => {
  return (
    <div className={styles.page__container}>
      <h2>Ошибка 404</h2>
      <h3>Страница не найдена</h3>
    </div>
  );
};
